import React, { CSSProperties } from 'react';
import * as S from './styles';

export interface IBoxContent {
  color: string;
  children: React.ReactNode;
  style?: CSSProperties;
  background?: string;
  onClick?: () => void;
}

export const BoxContent = ({
  color,
  children,
  style,
  background,
  onClick,
}: IBoxContent) => {
  return (
    <>
      <S.BoxContent
        color={color}
        style={style}
        background={background}
        onClick={onClick}
      >
        {children}
      </S.BoxContent>
    </>
  );
};
